import { render, staticRenderFns } from "./adfwer.vue?vue&type=template&id=5d2bb052&scoped=true"
import script from "./adfwer.vue?vue&type=script&lang=js"
export * from "./adfwer.vue?vue&type=script&lang=js"
import style0 from "./adfwer.vue?vue&type=style&index=0&id=5d2bb052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2bb052",
  null
  
)

export default component.exports